export default __webpack_public_path__ + "static/blob2-e89f249ea472c27a161f866c2d9e070f.svg";